/* Mobile nav - Prevent body scrolling */
const navToggler = document.querySelector('.navbar-toggler');
const myOffcanvas = document.getElementById('offcanvasNavbar');
const header = document.querySelector('.header');

myOffcanvas.addEventListener('show.bs.offcanvas',  ()=> {
    const headerOffset = header.getBoundingClientRect().top;
    myOffcanvas.style.setProperty('--header-offset', `${headerOffset}px`);
    navToggler.classList.toggle('menu-opened');
    navToggler.toggleAttribute('aria-expanded');
    window.lenis.destroy();
});
myOffcanvas.addEventListener('hide.bs.offcanvas', ()=> {
    navToggler.classList.toggle('menu-opened');
    navToggler.toggleAttribute('aria-expanded');
});
myOffcanvas.addEventListener('hiddent.bs.offcanvas', ()=> {
    window.lenis.start();
})